// @generated by protoc-gen-zod-es v0.0.1 with parameter "target=ts,import_extension=none"
// @generated from file tenki/cloud/identity/v1beta1/flow.proto (package tenki.cloud.identity.v1beta1, syntax proto3)
/* eslint-disable */

import { z } from "zod";

/**
 * @generated from message tenki.cloud.identity.v1beta1.Flow
 */
export const flowSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
  nodeCsrfToken: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.LoginFlow
 */
export const loginFlowSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
  loginMethod: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.RegistrationFlow
 */
export const registrationFlowSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.RecoveryFlow
 */
export const recoveryFlowSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
  state: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.VerificationFlow
 */
export const verificationFlowSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.SettingsFlow
 */
export const settingsFlowSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
  totpEnabled: z.boolean(),
  totpQr: z.string(),
  totpSecret: z.string(),
});
